import styled from 'styled-components';
import { mediaMobile } from 'utils/styles/responsive';
import { colors } from 'utils/styles/theme';
import RectParticles from 'assets/img/button-rectt-particles.png';
import RectParticlesMove from 'assets/img/button-rectt-particles-move.png';

export const Wrapper = styled.button`
    display: flex;
    width: 122rem;
    padding: 16px 0px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 12px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 10px;
    min-height: 150rem;
    pointer-events: all;
    transition: border-color 0.5s ease-in-out;

    
    
    ${mediaMobile(`
        gap: 8px;
        width: 70rem;
        min-height: 90rem;
    `)}


    .animated-border-box-particles {
       width: 115rem;
        height: 149rem;
        background-image: url(${RectParticles});
        background-position: 50% 100%;
        background-size: cover;
        position: absolute;
        border-radius: 10px;
        animation: alpha 4s linear infinite;
        pointer-events: none;
         ${mediaMobile(`
            width: 70rem;
            height: 87rem;    
        `)}
    }
    .animated-border-box-particles-move {
        position: absolute;
        width: 115rem;
        height: 147rem;
        background-image: url(${RectParticlesMove});
        background-position: 0% 0%;
        background-size: 100%;
        border-radius: 10px;
        animation: moveUp 10s infinite linear;
        opacity: 0.01;
        pointer-events: none;

        ${mediaMobile(`
            width: 70rem;
            height: 87rem;    
        `)}
    }
    .animated-border-box, .animated-border-box-glow{
        pointer-events: none;
        width: 122rem;
        height: 152rem;
        position: absolute;
        overflow: hidden; 
        z-index: 0;
        border-radius: 10px;
        ${mediaMobile(`
            width: 72rem;
            height: 90rem; 
        `)}
    }

    .animated-border-box-glow{
        overflow: hidden;
        /* Glow Blur */
        filter: blur(0px);
        transition: filter 1.3s ease-in-out;
    }

    .animated-border-box:before, .animated-border-box-glow:before {
        pointer-events: none;
        content: '';
        z-index: -2;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) rotate(0deg);
        position: absolute;
        width: 99999px;
        height: 99999px;
        background-repeat: no-repeat;
        background-position: 0 0;
        transition: background-image 1s 0.4s ease-in-out;
        background-image: conic-gradient(rgba(0,0,0,0), rgba(255,0,0,1), rgba(0,0,0,0) 50%);
    }

    
    &:hover, &.countdown {
         border: rgba(255,0,0,0) solid 1px !important;
        .animated-border-box-glow {
            filter: blur(10px);
        }
        > .animated-border-box:before, 
        .animated-border-box-glow:before {
            background-image: conic-gradient(rgba(0,0,0,0), ${colors.red}, rgba(0,0,0,0) 50%);
            transition: background-image 1s ease-in-out;
            animation: rotate 6s linear infinite;
        }
    }

    .animated-border-box:after {
        content: '';
        position: absolute;
        z-index: -1;
        left: 2px;
        top: 2px;
        width: calc(100% - 4px);
        height: calc(100% - 4px);
        /*bg color*/
        background: rgba(0,0,0,0.9);
        /*box border radius*/
        border-radius: 10px;
    }

    &.countdown {
        cursor: default;
        width: 300rem;
        .animated-border-box-particles {
            width: 295rem;
        }
        .animated-border-box-particles-move {
            width: 295rem;
            opacity: 0.05;
        }
        .animated-border-box {
            width: 300rem;
        }
        .animated-border-box-glow {
            width: 300rem;
        }      
            
        ${mediaMobile(`
            width: 180rem;
            .animated-border-box-particles {
                width: 175rem;
            }
            .animated-border-box-particles-move {
                width: 175rem;
            }
            .animated-border-box {
                width: 180rem;
            }
            .animated-border-box-glow {
                width: 180rem;
            }
        `)}
    }


    @keyframes rotate {
        100% {
            transform: translate(-50%, -50%) rotate(1turn);
        }
    }
    @keyframes alpha {
        0% {
            opacity: 0.3;
        }
        50% {
            opacity: 0.6;
        }
        100% {
            opacity: 0.3;
        }
    }
    @keyframes moveUp {
        from {
            background-position: 0% 0%;
        }
        to {          
            background-position: 0% -147rem;
        }
    }
`;

export const Icon = styled.div`
    width: 44rem;
    z-index: 2;
    > svg {
        width: 100%;
    }

    ${mediaMobile(`
        width: 22rem;
    `)}
`;

export const Label = styled.span`
    width: 100%;
    color: ${colors.white};
    text-align: center;
    font-family: FontRegular;
    font-size: 16rem;
    z-index: 2;
    ${mediaMobile(`
        font-size: 10rem;
    `)}
`;

export const Counter = styled.div`
    width: 100%;
    position: absolute;
    z-index: 4;
    transform: scale(0.6);

    ${Label} {
        font-size: 24rem;
    }
`